// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 388 ? "2fbf9dd2" : chunkId) + "." + {"388":"6ffee23cd409512e","532":"f956d59726c8cc39","651":"9078e83f25d7ee7c","741":"cd9485d61f910928"}[chunkId] + ".js";
};